import React from 'react';
import GrnForm from './GrnForm'; // Adjust path
import { useParams } from 'react-router-dom';

const EditGrnPage = () => {
    const { id } = useParams();
    // Fetch and pass data, handle loading state
    return id ? <GrnForm formType="edit" currentGrnId={id} /> : <div>Loading...</div>;
};
export default EditGrnPage;